import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { FormControl, TextField } from "@material-ui/core";
import { Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
    addParametrs,
    getParametrosByHash,
    createCampaign,
    updateCampaign,
    updateParametrs,
    deleteParametros,
    deleteCampania,
} from "../api";
import { Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { Fab } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CampaingItem from "../../components/campaing-items/CampaingItem";
import { CampContext } from "../../context/CampContext";
import { ParamsContext } from "../../context/ParamsContext";
import Loader from "react-block-ui/lib/Loader";
import AlertDialog from "../../components/alert-dialog/AlertDialog";
import ConfirmAlert from "../../components/alert-dialog/ConfirmAlert";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(8),
        marginLeft: theme.spacing(8),
        marginRight: theme.spacing(8),
        marginBottom: theme.spacing(3),
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
        height: "100%",
    },
    paperMain: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    textField: {
        marginTop: theme.spacing(3),
        alignSelf: "center",
    },
    textFieldFull: {
        marginTop: theme.spacing(3),
        width: "80%",
        alignSelf: "center",
    },
    textFieldM: {
        marginTop: theme.spacing(3),
        width: "65%",
        alignSelf: "center",
    },
    button: {
        margin: theme.spacing(1),
        width: "15px",
    },
    container: {
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "50px",
    },
    alert: {
        width: "100%",
        height: "300px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    },
    form: {
        width: "100%",
    },
    formContainer: {
        margin: "24px auto",
    },
    loader: {
        width: "100%",
        height: "300px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
}));

const AddParameters = (props) => {
    const classes = useStyles();

    const { state, setState, resetState } = useContext(CampContext);
    const { paramsState, setParamsState, resetParamsState } = useContext(
        ParamsContext
    );

    const [deshabilitado, setDeshabilitado] = useState(false);
    const [error, setError] = useState("");

    const [showAlert, setAlert] = useState({
        show: false,
        title: "",
        msg: "",
        onClose: () => {},
    });

    const [showConfirm, setConfirm] = useState({
        show: false,
        title: "",
        msg: "",
        onClose: () => {},
        onConfirm: () => {},
    });

    const [loading, setLoading] = useState(true);
    const [savingData, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const [imgbg, setImgbg] = useState(true);

    const [logo, setLogo] = useState(true);

    const [warning, setWarning] = useState(false);
    const [checklogo, setChecklogo] = useState(false);
    const [checkimage, setCheckimage] = useState(false);

    const validation = Yup.object().shape({
        imagenLogo: Yup.string().required(),
        imagenBackground: Yup.string().required(),
        texto: Yup.string().required("Requerido"),
    });

    const handleSubmit = (values) => {
        const payload = { ...values, estrategia: { id: values.estrategia.id } };

        if (state.action === "new") {
            addParametrsFunc(payload);
        } else if (state.action === "edit") {
            updateParametrsFunc(payload);
        }
    };

    const formik = useFormik({
        initialValues: paramsState,
        validationSchema: validation,
        onSubmit: handleSubmit,
    });

    async function addParametrsFunc(obj) {
        try {
            await addParametrs(obj);

            setAlert({
                show: true,
                title: "Exito",
                msg: "Campaña creada correctamente",
                onClose: () => {
                    setAlert({ ...showAlert, show: false });
                    window.location.reload();
                },
            });
        } catch (error) {
            setError("Ocurrio un Error");
        }
    }

    async function updateParametrsFunc(obj) {
        try {
            await updateParametrs(obj);

            setAlert({
                show: true,
                title: "Exito",
                msg: "Campaña actualizada correctamente",
                onClose: () => {
                    setAlert({ ...showAlert, show: false });
                    window.location.reload();
                },
            });
        } catch (error) {
            setError("Ocurrio un Error");
        }
    }

    async function createCampaignFunc(obj) {
        try {
            const res = await createCampaign(obj);
            if (res.data.id) {
                formik.setFieldValue("hash", res.data.hash);
                formik.setFieldValue("estrategia", { id: res.data.id });
                formik.handleSubmit();
            }
        } catch (error) {
            setError("Ocurrio un Error");
        }
    }

    async function updateCampaignFunc(obj) {
        try {
            await updateCampaign(obj);
            formik.handleSubmit();
        } catch (error) {
            setError("Ocurrio un Error");
        }
    }

    const guardar = async () => {
        if (
            formik.values.imagenBackground === "" ||
            formik.values.imagenLogo === "" ||
            formik.values.texto === ""
        ) {
            setImgbg(false);
            setLogo(false);
            setWarning(true);
        } else {
            setSaving(true);
            setDeshabilitado(true);
            if (state.action === "new") {
                createCampaignFunc(state.currentCamp);
            } else if (state.action === "edit" && state.currentCamp.id) {
                updateCampaignFunc(state.currentCamp);
            }
        }
    };

    const eliminar = () => {
        setConfirm({
            show: true,
            title: "Eliminar Campaña",
            msg: "Seguro que desea Eliminar?",
            onClose: () => setConfirm({ ...showConfirm, show: false }),
            onConfirm: async () => {
                setDeleting(true);
                setDeshabilitado(true);
                setConfirm({ ...showConfirm, show: false });

                try {
                    const paramsId = paramsState.id;
                    const campId = paramsState.estrategia.id;
                    //eliminar params
                    await deleteParametros(paramsId);
                    //eliminar campaña
                    await deleteCampania(campId);

                    setAlert({
                        show: true,
                        title: "Exito",
                        msg: "Campaña eliminada Correctamente",
                        onClose: () => window.location.reload(),
                    });
                } catch (error) {
                    setError("Ocurrio un Error");
                }
            },
        });
    };

    const label = (label) => {
        <p id="label">{label}</p>;
    };

    const handleChangeSMS = () => {
        if (formik.values.validaSms == false) {
            formik.setFieldValue("validaSms", true);
        }
        if (formik.values.validaSms == true) {
            formik.setFieldValue("validaSms", false);
        }
    };
    const handleChangeEMAIL = () => {
        if (formik.values.validaEmail == false) {
            formik.setFieldValue("validaEmail", true);
        }
        if (formik.values.validaEmail == true) {
            formik.setFieldValue("validaEmail", false);
        }
    };
    const handleChangeScore = () => {
        if (formik.values.validaScore == false) {
            formik.setFieldValue("validaScore", true);
        }
        if (formik.values.validaScore == true) {
            formik.setFieldValue("validaScore", false);
        }
    };
    const handleChangeProvincia = () => {
        if (formik.values.habilitaProvincia == false) {
            formik.setFieldValue("habilitaProvincia", true);
        }
        if (formik.values.habilitaProvincia == true) {
            formik.setFieldValue("habilitaProvincia", false);
            //deshabilito localidad
            formik.setFieldValue("habilitaLocalidad", false);
        }
    };
    const handleChangeLocalidad = () => {
        if (formik.values.habilitaLocalidad == false) {
            formik.setFieldValue("habilitaLocalidad", true);
            //habilito provincia
            formik.setFieldValue("habilitaProvincia", true);
        }
        if (formik.values.habilitaLocalidad == true) {
            formik.setFieldValue("habilitaLocalidad", false);
        }
    };

    const setFormikValues = (values) => {
        const keys = Object.keys(values);
        keys.forEach((key) => formik.setFieldValue(key, values[key]));
    };

    const getParamsByHash = async (id) => {
        try {
            setLoading(true);
            const res = await getParametrosByHash(id);
            setParamsState(res.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError("Error de red o sin parametros");
        }
    };

    //cuando trae parametros de api actualizar form values
    useEffect(() => {
        if (paramsState.id) {
            setFormikValues(paramsState);
        }
    }, [paramsState]);

    const uploadlogo = async (e) => {
        const file = e.target.files[0];
        const base64 = await convertBase64(file);
        var strImage = base64.replace(/^data:image\/[a-z]+;base64,/, "");
        formik.setFieldValue("imagenLogo", strImage);
        setChecklogo(true);
    };
    const uploadImagen = async (e) => {
        const file = e.target.files[0];
        const base64 = await convertBase64(file);
        var strImage = base64.replace(/^data:image\/[a-z]+;base64,/, "");
        formik.setFieldValue("imagenBackground", strImage);
        setCheckimage(true);
    };
    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };
    function errorText(w, ml, mr) {
        return (
            <div>
                <Divider
                    style={{
                        width: w,
                        backgroundColor: "red",
                        marginTop: "2%",
                        marginLeft: ml,
                    }}
                />
                <p
                    style={{
                        marginTop: "0px",
                        marginRight: mr,
                        fontSize: "10pt",
                        color: "red",
                    }}
                >
                    requerido
                </p>
            </div>
        );
    }

    //si es una campaña ya creada pide los params
    useEffect(() => {
        if (
            state.action === "edit" &&
            state.currentCamp.id &&
            !paramsState.id
        ) {
            getParamsByHash(state.currentCamp.hash);
        } else {
            setLoading(false);
        }
    }, []);

    const handleVolver = () => {
        if (state.action === "new") {
            setState({
                ...state,
                form: true,
                param: false,
            });
        } else if (state.action === "edit") {
            resetParamsState();
            setState({
                ...state,
                search: true,
                param: false,
            });
        }
    };

    if (loading && !error) {
        return (
            <div
            className={classes.loader}
        >
            <div>Cargando</div>
            <Loader />
        </div>
        );
    }


    if (error !== "") {
        return (
            <div className={classes.alert}>
                <Typography component={"span"} style={{ fontSize: "16px" }}>
                    {error}
                </Typography>
                <Button
                    style={{ alignSelf: "center", marginTop: "16px" }}
                    bsStyle="primary"
                    id="btn-primary"
                    onClick={handleVolver}
                >
                    Volver
                </Button>
            </div>
        );
    }

    return (
        <div>
            <Grid
                item
                xs={11}
                sm={10}
                md={8}
                lg={6}
                xl={5}
                className={classes.container}
            >
                <CampaingItem campania={state.currentCamp} parent="params" />
            </Grid>

            <form
                id="params"
                onSubmit={formik.handleSubmit}
                className={classes.form}
            >
                <Grid item xs={11} lg={10} className={classes.formContainer}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Paper className={classes.paper} elevation={3}>
                                {/*upload logo*/}
                                <div
                                    style={{
                                        marginTop: "8%",
                                        marginRight: "50%",
                                    }}
                                >
                                    {formik.values.imagenLogo && (
                                        <img
                                            src={
                                                "data:image/*;base64," +
                                                formik.values.imagenLogo
                                            }
                                            width="70%"
                                        />
                                    )}
                                    <h3>Upload logo</h3>

                                    <FormControl>
                                        <label htmlFor="imagenLogo">
                                            <input
                                                style={{ display: "none" }}
                                                id="imagenLogo"
                                                name="imagenLogo"
                                                type="file"
                                                accept="image/*"
                                                disabled={deshabilitado}
                                                onChange={(e) => {
                                                    uploadlogo(e);
                                                }}
                                            />
                                            <Fab
                                                disabled={deshabilitado}
                                                color="secondary"
                                                size="small"
                                                component="span"
                                                aria-label="add"
                                                variant="extended"
                                            >
                                                <AddIcon /> Upload logo
                                            </Fab>
                                        </label>
                                    </FormControl>

                                    {checklogo === true && (
                                        <div>
                                            <CheckCircleIcon
                                                fontSize="large"
                                                color="primary"
                                            />
                                        </div>
                                    )}
                                </div>
                                {logo == false && errorText("60%", "0%", "40%")}

                                {/*upload image*/}
                                <div
                                    style={{
                                        marginTop: formik.values
                                            .imagenBackground
                                            ? "20%"
                                            : "40%",
                                    }}
                                >
                                    {formik.values.imagenBackground && (
                                        <img
                                            src={
                                                "data:image/*;base64," +
                                                formik.values.imagenBackground
                                            }
                                            width="80%"
                                        />
                                    )}

                                    <h3
                                        style={{
                                            marginLeft: "3%",
                                        }}
                                    >
                                        Upload imagen campaña
                                    </h3>
                                    <FormControl>
                                        <label htmlFor="imagenBackground">
                                            <input
                                                style={{ display: "none" }}
                                                id="imagenBackground"
                                                name="imagenBackground"
                                                type="file"
                                                accept="image/*"
                                                disabled={deshabilitado}
                                                onChange={(e) => {
                                                    uploadImagen(e);
                                                }}
                                            />
                                            <Fab
                                                disabled={deshabilitado}
                                                color="secondary"
                                                size="small"
                                                component="span"
                                                aria-label="add"
                                                variant="extended"
                                            >
                                                <AddIcon /> Upload imagen
                                            </Fab>
                                        </label>
                                    </FormControl>
                                    {checkimage == true && (
                                        <div>
                                            <CheckCircleIcon
                                                fontSize="large"
                                                color="primary"
                                            />
                                        </div>
                                    )}
                                </div>
                                {imgbg == false &&
                                    errorText("70%", "16%", "0%")}

                                {/*texto sobre imagen*/}
                                <FormControl
                                    style={{
                                        marginTop: "21%",
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldFull}
                                        placeholder="Texto sobre imagen campaña (opcional)"
                                        label={label(
                                            "Texto sobre imagen campaña (opcional)"
                                        )}
                                        disabled={deshabilitado}
                                        name="textoSobreImagen"
                                        onChange={formik.handleChange}
                                        value={formik.values.textoSobreImagen}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.textoSobreImagen
                                        }
                                        error={
                                            formik.errors.textoSobreImagen
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Paper className={classes.paper} elevation={3}>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldFull}
                                        placeholder="Titulo encabezado"
                                        label={label("Titulo encabezado")}
                                        disabled={deshabilitado}
                                        name="texto"
                                        onChange={formik.handleChange}
                                        value={formik.values.texto}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.texto &&
                                            !formik.values.texto && (
                                                <Typography
                                                    component={"span"}
                                                    style={{ fontSize: "14px" }}
                                                >
                                                    {formik.errors.texto}
                                                </Typography>
                                            )
                                        }
                                        error={
                                            formik.errors.texto &&
                                            !formik.values.texto
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>

                                <Grid container>
                                    <Grid item xs={6}>
                                        <FormControl>
                                            <TextField
                                                className={classes.textField}
                                                disabled={true}
                                                placeholder="DNI"
                                                label={label("DNI")}
                                                name="validaDni"
                                                variant="outlined"
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl>
                                            <TextField
                                                className={classes.textField}
                                                placeholder="Nombre"
                                                label={label("Nombre")}
                                                disabled={true}
                                                name="nombre"
                                                variant="outlined"
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <TextField
                                            className={classes.textField}
                                            placeholder="Apellido"
                                            label={label("Apellido")}
                                            disabled={true}
                                            name="Apellido"
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            className={classes.textField}
                                            placeholder="Prefijo"
                                            label={label("Prefijo")}
                                            disabled={true}
                                            name="Prefijo"
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <TextField
                                            className={classes.textField}
                                            placeholder="Telefono"
                                            label={label("Telefono")}
                                            name="Telefono"
                                            disabled={true}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            className={classes.textField}
                                            placeholder="Email"
                                            label={label("Email")}
                                            name="Email"
                                            disabled={true}
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            flexDirection: "column",
                                        }}
                                        item
                                        xs
                                    >
                                        <FormGroup
                                            style={{
                                                alignSelf: "center",
                                                marginTop: "5%",
                                            }}
                                            row
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        name="habilitaProvincia"
                                                        checked={
                                                            formik.values
                                                                .habilitaProvincia
                                                        }
                                                        disabled={deshabilitado}
                                                        onChange={
                                                            handleChangeProvincia
                                                        }
                                                    />
                                                }
                                                label={<h4>Provincia</h4>}
                                            />
                                        </FormGroup>
                                    </Grid>
                                    <Grid
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            flexDirection: "column",
                                        }}
                                        item
                                        xs
                                    >
                                        <FormGroup
                                            style={{
                                                alignSelf: "center",
                                                marginTop: "5%",
                                            }}
                                            row
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        name="habilitaLocalidad"
                                                        checked={
                                                            formik.values
                                                                .habilitaLocalidad
                                                        }
                                                        disabled={deshabilitado}
                                                        onChange={
                                                            handleChangeLocalidad
                                                        }
                                                    />
                                                }
                                                label={<h4>Localidad</h4>}
                                            />
                                        </FormGroup>
                                    </Grid>
                                </Grid>
                                <Grid
                                    style={{
                                        marginTop: "2%",
                                    }}
                                    container
                                >
                                    <Grid
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            flexDirection: "column",
                                        }}
                                        item
                                        xs
                                    >
                                        <FormGroup
                                            style={{
                                                alignSelf: "center",
                                                marginTop: "3%",
                                            }}
                                            row
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        name="validaSms"
                                                        checked={
                                                            formik.values
                                                                .validaSms
                                                        }
                                                        disabled={deshabilitado}
                                                        onChange={
                                                            handleChangeSMS
                                                        }
                                                    />
                                                }
                                                label={<h4>Valida SMS</h4>}
                                            />
                                        </FormGroup>
                                    </Grid>
                                    <Grid
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            flexDirection: "column",
                                        }}
                                        item
                                        xs
                                    >
                                        <FormGroup
                                            style={{
                                                alignSelf: "center",
                                                marginTop: "3%",
                                            }}
                                            row
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        name="validaEmail"
                                                        checked={
                                                            formik.values
                                                                .validaEmail
                                                        }
                                                        disabled={deshabilitado}
                                                        onChange={
                                                            handleChangeEMAIL
                                                        }
                                                    />
                                                }
                                                label={<h4>Valida Email</h4>}
                                            />
                                        </FormGroup>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            flexDirection: "column",
                                        }}
                                        item
                                        xs
                                    >
                                        <FormGroup
                                            style={{
                                                alignSelf: "center",
                                                marginTop: "3%",
                                            }}
                                            row
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        name="validaScore"
                                                        checked={
                                                            formik.values
                                                                .validaScore
                                                        }
                                                        disabled={deshabilitado}
                                                        onChange={
                                                            handleChangeScore
                                                        }
                                                    />
                                                }
                                                label={<h4>Valida Score</h4>}
                                            />
                                        </FormGroup>
                                    </Grid>
                                </Grid>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldM}
                                        placeholder="Titulo 1 pie formulario (opcional)"
                                        label={label(
                                            "Titulo 1 pie formulario (opcional)"
                                        )}
                                        disabled={deshabilitado}
                                        name="titulo1Formulario"
                                        onChange={formik.handleChange}
                                        value={formik.values.titulo1Formulario}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.titulo1Formulario
                                        }
                                        error={
                                            formik.errors.titulo1Formulario
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldM}
                                        placeholder="Detalle 1 pie formulario (opcional)"
                                        label={label(
                                            "Detalle 1 pie formulario (opcional)"
                                        )}
                                        disabled={deshabilitado}
                                        name="detalle1Formulario"
                                        onChange={formik.handleChange}
                                        value={formik.values.detalle1Formulario}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.detalle1Formulario
                                        }
                                        error={
                                            formik.errors.detalle1Formulario
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldM}
                                        placeholder="Titulo 2 pie formulario (opcional)"
                                        label={label(
                                            "Titulo 2 pie formulario (opcional)"
                                        )}
                                        disabled={deshabilitado}
                                        name="titulo2Formulario"
                                        onChange={formik.handleChange}
                                        value={formik.values.titulo2Formulario}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.titulo2Formulario
                                        }
                                        error={
                                            formik.errors.titulo2Formulario
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldM}
                                        placeholder="Detalle 2 pie formulario (opcional)"
                                        label={label(
                                            "Detalle 2 pie formulario (opcional)"
                                        )}
                                        disabled={deshabilitado}
                                        name="detalle2Formulario"
                                        onChange={formik.handleChange}
                                        value={formik.values.detalle2Formulario}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.detalle2Formulario
                                        }
                                        error={
                                            formik.errors.detalle2Formulario
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldM}
                                        placeholder="Titulo 3 pie formulario (opcional)"
                                        label={label(
                                            "Titulo 3 pie formulario (opcional)"
                                        )}
                                        name="titulo3Formulario"
                                        disabled={deshabilitado}
                                        onChange={formik.handleChange}
                                        value={formik.values.titulo3Formulario}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.titulo3Formulario
                                        }
                                        error={
                                            formik.errors.titulo3Formulario
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldM}
                                        placeholder="Detalle 3 pie formulario (opcional)"
                                        label={label(
                                            "Detalle 3 pie formulario (opcional)"
                                        )}
                                        disabled={deshabilitado}
                                        name="detalle3Formulario"
                                        onChange={formik.handleChange}
                                        value={formik.values.detalle3Formulario}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.detalle3Formulario
                                        }
                                        error={
                                            formik.errors.detalle3Formulario
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldM}
                                        placeholder="Titulo 4 pie formulario (opcional)"
                                        label={label(
                                            "Titulo 4 pie formulario (opcional)"
                                        )}
                                        disabled={deshabilitado}
                                        name="titulo4Formulario"
                                        onChange={formik.handleChange}
                                        value={formik.values.titulo4Formulario}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.titulo4Formulario
                                        }
                                        error={
                                            formik.errors.titulo4Formulario
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldM}
                                        placeholder="Detalle 4 pie formulario (opcional)"
                                        label={label(
                                            "Detalle 4 pie formulario (opcional)"
                                        )}
                                        disabled={deshabilitado}
                                        name="detalle4Formulario"
                                        onChange={formik.handleChange}
                                        value={formik.values.detalle4Formulario}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.detalle4Formulario
                                        }
                                        error={
                                            formik.errors.detalle4Formulario
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldM}
                                        placeholder="Titulo 5 pie formulario (opcional)"
                                        label={label(
                                            "Titulo 5 pie formulario (opcional)"
                                        )}
                                        disabled={deshabilitado}
                                        name="titulo5Formulario"
                                        onChange={formik.handleChange}
                                        value={formik.values.titulo5Formulario}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.titulo5Formulario
                                        }
                                        error={
                                            formik.errors.titulo5Formulario
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                                <FormControl
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <TextField
                                        className={classes.textFieldM}
                                        label={label(
                                            "Detalle 5 pie formulario (opcional)"
                                        )}
                                        placeholder="Detalle 5 pie formulario (opcional)"
                                        disabled={deshabilitado}
                                        name="detalle5Formulario"
                                        onChange={formik.handleChange}
                                        value={formik.values.detalle5Formulario}
                                        variant="outlined"
                                        helperText={
                                            formik.errors.detalle5Formulario
                                        }
                                        error={
                                            formik.errors.detalle5Formulario
                                                ? true
                                                : false
                                        }
                                    />
                                </FormControl>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>

                <Divider
                    style={{
                        backgroundColor: "black",
                        marginLeft: "5%",
                        marginRight: "5%",
                    }}
                />
                <Grid container spacing={0} style={{ paddingBottom: "2%" }}>
                    <Grid
                        item
                        xs
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                        }}
                    >
                        <FormControl
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                            }}
                        >
                            <TextField
                                className={classes.textFieldFull}
                                label={label("Texto pie imagen (opcional)")}
                                placeholder="Texto pie imagen (opcional)"
                                disabled={deshabilitado}
                                name="textoDebajoImagen"
                                onChange={formik.handleChange}
                                value={formik.values.textoDebajoImagen}
                                variant="outlined"
                                helperText={formik.errors.textoDebajoImagen}
                                error={
                                    formik.errors.textoDebajoImagen
                                        ? true
                                        : false
                                }
                            />
                        </FormControl>
                    </Grid>
                    <Grid
                        item
                        xs
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                        }}
                    >
                        <FormControl
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                            }}
                        >
                            <TextField
                                className={classes.textFieldFull}
                                label={label(
                                    "Texto final formulario (opcional)"
                                )}
                                placeholder="Texto final formulario (opcional)"
                                disabled={deshabilitado}
                                name="textoPieFormulario"
                                onChange={formik.handleChange}
                                value={formik.values.textoPieFormulario}
                                variant="outlined"
                                helperText={formik.errors.textoPieFormulario}
                                error={
                                    formik.errors.textoPieFormulario
                                        ? true
                                        : false
                                }
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    {warning && (
                        <Grid
                            item
                            xs={12}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                            }}
                        >
                            {" "}
                            <p
                                style={{
                                    color: "red",
                                    alignSelf: "center",
                                    fontSize: "18px",
                                }}
                            >
                                Revise los campos requeridos
                            </p>
                        </Grid>
                    )}

                    <Grid
                        item
                        xs={11}
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            margin: "16px auto",
                        }}
                    >
                        {" "}
                        <Button
                            style={{ maxWidth: "120px" }}
                            bsStyle="primary"
                            id="btn-primary"
                            disabled={deshabilitado}
                            onClick={handleVolver}
                        >
                            Volver
                        </Button>
                        {deleting && (
                            <div
                                style={{
                                    textAlign: "center",
                                    marginRight: "16px",
                                }}
                            >
                                Eliminando
                                <Loader />
                            </div>
                        )}
                        {state.action === 'edit' && !deleting && (
                            <Button
                                style={{ maxWidth: "120px" }}
                                id="btn-primary"
                                bsStyle="danger"
                                disabled={deshabilitado}
                                onClick={eliminar}
                            >
                                Eliminar
                            </Button>
                        )}
                        {savingData && (
                            <div
                                style={{
                                    textAlign: "center",
                                    marginRight: "16px",
                                }}
                            >
                                Guardando
                                <Loader />
                            </div>
                        )}
                        {!savingData && (
                            <Button
                                style={{ maxWidth: "120px" }}
                                id="btn-primary"
                                bsStyle="primary"
                                disabled={deshabilitado}
                                onClick={guardar}
                            >
                                Guardar
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </form>

            <AlertDialog
                show={showAlert.show}
                onClose={showAlert.onClose}
                title={showAlert.title}
                message={showAlert.msg}
            />

            <ConfirmAlert
                show={showConfirm.show}
                onClose={showConfirm.onClose}
                onConfirm={showConfirm.onConfirm}
                title={showConfirm.title}
                message={showConfirm.msg}
            />
        </div>
    );
};
export default AddParameters;



// WEBPACK FOOTER //
// ./src/scenes/Parametros/AddParameters.js